import { isPlatformBrowser } from '@angular/common';
import { HttpErrorResponse } from '@angular/common/http';
import { ErrorHandler, Inject, Injectable, Injector, PLATFORM_ID } from '@angular/core';
import { CaptureSource, getTelemetryClient } from 'smash-telemetry';
import { ErrorService } from '../services/error.service';
import { LoggerService } from '../services/logger.service';


@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
    constructor(
        private injector: Injector,
        @Inject(PLATFORM_ID) private platformId: any
    ) {
    }

    handleError(error: Error | HttpErrorResponse) {
        const errorService = this.injector.get(ErrorService);
        const logger = this.injector.get(LoggerService);
        let message;
        let stackTrace;
        if (isPlatformBrowser(this.platformId)) {
            // Client Error
            message = errorService.getClientMessage(error);
            stackTrace = errorService.getClientStack(error);
        } else {
            // Server Error
            message = errorService.getServerMessage(error);
        }
        // Always log errors
        logger.error(message, stackTrace);

        // Forwarded to smash-telemetry, whose ingestion endpoint is unauthenticated (no SigV4
        // signing, so no Node Buffer dependency) — see core/telemetry/bootstrapTelemetry.ts. A
        // safe no-op server-side and before bootstrapTelemetry() has called start().
        getTelemetryClient().captureError(error, CaptureSource.AngularErrorHandler);
    }
}
